module.exports = __webpack_public_path__ + "static/media/icon-action-sms.c085e13d.svg";